module.exports = __webpack_public_path__ + "img/DE00717.ef7d3601.png";